var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterBg = function SvgTwitterBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#191A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.843 11.01C29.8922 11.6806 28.8395 12.1936 27.7254 12.5291C27.1274 11.8415 26.3327 11.3542 25.4488 11.133C24.5649 10.9118 23.6343 10.9675 22.783 11.2924C21.9317 11.6173 21.2007 12.1959 20.689 12.9498C20.1772 13.7037 19.9093 14.5965 19.9215 15.5077V16.5005C18.1767 16.5458 16.4477 16.1588 14.8887 15.3741C13.3296 14.5893 11.9888 13.4312 10.9857 12.0028C10.9857 12.0028 7.01427 20.9386 15.95 24.9101C13.9053 26.2981 11.4694 26.994 9 26.8958C17.9358 31.8601 28.8573 26.8958 28.8573 15.4779C28.8563 15.2013 28.8298 14.9254 28.7778 14.6538C29.7912 13.6545 30.5062 12.3928 30.843 11.01Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-bg.e71027d1.svg";
export { ForwardRef as ReactComponent };